import '~/js/modules/section-hero';
import '~/js/libs/jquery-ui.selectmenu.min.js';
import activitiesByResort from './land-sports-data.js';

const $resortSelect = $('#js-resort-select');
const $activitiesList = $('.activities__list');

const createListElement = (activity) => {
  const listItem = document.createElement('li');

  listItem.append(activity);
  $activitiesList.append(listItem);
};

const showAllActivities = (activities) => {
  const resortKeys = Object.keys(activitiesByResort);

  // Creating and looping an array with all resort activities
  [...new Set(resortKeys.reduce((accu, curr) => [...accu, ...activities[curr]], []))].map((activity) => createListElement(activity));

  $activitiesList.children().addClass('activities__item');
};

const createActivityList = (activities, resortChecked) => {
  // Clear current activity list.
  $activitiesList.empty();

  if(activities && resortChecked !== 'default') {
    const resortActivities = activities[resortChecked];

    // Creating activity list based on user selection.
    resortActivities.map((activity) => createListElement(activity));

    $activitiesList.children().addClass('activities__item');

  } else if (resortChecked === 'default') {

    showAllActivities(activities);
  }
};

const selectHandler = (event, { item }) => {
  const element = item;
  const resortChecked = item.value;

  if(element) {
    createActivityList(activitiesByResort, resortChecked);
  }
};

// Show all activities when page loads for the first time
showAllActivities(activitiesByResort);

// Initializing resort select handler
$resortSelect.selectmenu({
  select: selectHandler
});
